import React from 'react'

const FinalFormP = () => {
  return (
    <div className='m-3 bg-white text-black p-5 '>
        <div className="text-center  mb-4">
            <h2>FORM - P</h2>
            <h2>[SEE RULE 121(9)]</h2>
            <h2 className='mx-5 px-5'>FORM OF ANNUAL ACCOUNTS OF CONTRACT FARMING SPONSOR</h2>
        </div>

        <div id='table' className='w-100 overflow-hidden border bg-white border-secondary rounded'>
            <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <div className='col-6 d-flex'>
                    <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Sr. No.</h4>
                    <h4 className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>Name of the commodity</h4>
                    <h4 className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>No. of farmers with whom contracts signed</h4>
                    <h4 className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>Area in ha. under contract Farming Agreement</h4>
                    <h4 className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>Quantity purchased in tones</h4>
                </div>
                <div className='col-6 d-flex'>
                    <h4 className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>Total value and quantity of produce purchased</h4>
                    <h4 className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>Values paid to the farmers</h4>
                    <div className='col-6'>
                        <div className='border-bottom border-secondary'>
                            <h4 className='p-2 justify-content-center d-flex'>Payment outstanding for more than 15 days</h4>
                        </div>
                        <div className='d-flex h-100'>
                            <h4 className='col-6 p-2 justify-content-center d-flex border-secondary border-end'>No. of farmers</h4>
                            <h4 className='col-6 p-2 justify-content-center d-flex'>Amount in Rs.</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div id='body' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' >
                <div className='col-6 d-flex'>
                    <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>1</p>
                    </div>
                    <div className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>Priyansh</p>
                    </div>
                    <div className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>3</p>
                    </div>
                    <div className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>5 ha.</p>
                    </div>
                    <div className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>8</p>
                    </div>
                </div>
                <div className='col-6 d-flex'>
                    <div className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>3 & 5 tonnes</p>
                    </div>
                    <div className='col-3 p-2 justify-content-center d-flex border-secondary border-end'>
                        <p>Rs 40,000</p>
                    </div>
                    <div className='col-6'>
                        <div className='d-flex h-100'>
                            <div className='col-6 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>4</p>
                            </div>
                            <div className='col-6 p-2 justify-content-center d-flex'>
                                <p>Rs. 30,000</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FinalFormP